import { render, staticRenderFns } from "./manage-group-patients.vue?vue&type=template&id=dcf988a2&scoped=true"
import script from "./manage-group-patients.vue?vue&type=script&lang=js"
export * from "./manage-group-patients.vue?vue&type=script&lang=js"
import style0 from "./manage-group-patients.vue?vue&type=style&index=0&id=dcf988a2&prod&scoped=true&lang=css"
import style1 from "./manage-group-patients.vue?vue&type=style&index=1&id=dcf988a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf988a2",
  null
  
)

export default component.exports